<template>
  <v-app>
    <v-container v-show="loading" fluid class="container-reset">
      <v-layout align-center justify-center fill-height>
        <v-card light class="card-loading">
          <v-card-text>
            <v-flex style="margin-top: 20%;" mb-4>
              <v-progress-circular
                :size="80"
                :width="6"
                color="light-blue accent-4"
                indeterminate
              />
            </v-flex>
            <span>Loading ...</span>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-container>
    <v-container v-show="!loading" fluid class="container-reset">
      <v-layout class="box-layout" align-center justify-center>
        <v-flex class="box-reset">
          <h2>Change Password</h2>
          <v-form @keyup.native.enter="login">
            <v-card class="card" light>
              <v-card-text>
                <v-flex>
                  <v-text-field
                    v-model="password"
                    placeholder="********"
                    :append-icon="
                      showPassword1 ? 'visibility' : 'visibility_off'
                    "
                    :type="showPassword1 ? 'text' : 'password'"
                    @click:append="showPassword1 = !showPassword1"
                    @keyup.enter="changePassword"
                    solo
                  />
                  <v-text-field
                    v-model="passwordConfirm"
                    placeholder="********"
                    :append-icon="
                      showPassword2 ? 'visibility' : 'visibility_off'
                    "
                    :type="showPassword2 ? 'text' : 'password'"
                    @click:append="showPassword2 = !showPassword2"
                    @keyup.enter="changePassword"
                    solo
                  />
                </v-flex>
                <v-flex mt-4>
                  <v-btn
                    @click="changePassword"
                    class="font-weight-thin reset-btn-confirm"
                    :color="buttonColor"
                    :disabled="!statusBtn"
                    :loading="loadingBtn"
                    block
                    dark
                  >
                    Confirm
                  </v-btn>
                  <v-btn
                    @click="cancelChangePassword"
                    class="font-weight-thin"
                    style="outline:none; text-transform: none;"
                    flat
                    round
                    small
                    dark
                  >
                    Cancel
                  </v-btn>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-form>
        </v-flex>
        <v-flex class="recommend" column>
          <h4>password must contain:</h4>
          <h5
            :style="
              password === ''
                ? 'color: #C4C4C4;'
                : checkCharacters
                ? 'color: green;'
                : 'color: red;'
            "
          >
            At least 12 characters
          </h5>
          <h5
            :style="
              password === ''
                ? 'color: #C4C4C4;'
                : checkUpperCase
                ? 'color: green;'
                : 'color: red;'
            "
          >
            At least 1 upper case letter (A-Z)
          </h5>
          <h5
            :style="
              password === ''
                ? 'color: #C4C4C4;'
                : checkLowerCase
                ? 'color: green;'
                : 'color: red;'
            "
          >
            At least 1 lowwer case letter (a-z)
          </h5>
          <h5
            :style="
              password === ''
                ? 'color: #C4C4C4;'
                : checkSpecialCharacter
                ? 'color: green;'
                : 'color: red;'
            "
          >
            At least 1 special character
          </h5>
          <h5
            :style="
              password === ''
                ? 'color: #C4C4C4;'
                : checkNumber
                ? 'color: green;'
                : 'color: red;'
            "
          >
            At least 1 number (0-9)
          </h5>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- dialog success change password -->
    <div class="text-xs-center">
      <v-dialog v-model="isDialogSucessShown" width="800" persistent>
        <v-card class="success-change">
          <v-card-text class="text-md-left">
            <v-layout class="box-success" column>
              <v-icon class="icon-Success">check</v-icon>
              <h3>Your password changed</h3>
              <span>go back to sign in ... {{ coundown }} second</span>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-snackbar
      v-model="snackbar"
      :bottom="false"
      :left="false"
      :multi-line="true"
      :right="false"
      :timeout="6000"
      :top="true"
      :vertical="false"
    >
      {{ snackbartext }}
      <v-btn color="pink" flat style="outline: none;" @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  name: "resetPassword",
  beforeCreate() {
    sessionStorage.removeItem("user-token");
  },
  data() {
    return {
      buttonColor: null,
      password: "",
      passwordConfirm: "",
      token: "",
      loading: true,
      background: null,
      snackbar: false,
      snackbartext: "",
      showPassword1: false,
      showPassword2: false,
      statusBtn: false,
      checkCharacters: false,
      checkUpperCase: false,
      checkNumber: false,
      checkLowerCase: false,
      checkSpecialCharacter: false,
      isDialogSucessShown: false,
      coundown: 5,
      refreshIntervalId: null,
      loadingBtn: false
    };
  },
  created() {
    this.token = this.$route.query.token;
    this.buttonColor = "#015D72";
    this.background = `background-image: url(${require("../assets/img/bg-blue.jpg")});
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;`;
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
  methods: {
    async changePassword() {
      this.loadingBtn = true;
      try {
        if (this.password !== this.passwordConfirm) {
          this.snackbartext = "Password do not match";
          this.snackbar = true;
          this.loadingBtn = false;
        } else {
          if (
            this.checkCharacters &&
            this.checkUpperCase &&
            this.checkNumber &&
            this.checkLowerCase &&
            this.checkSpecialCharacter
          ) {
            await axios.post(apiUrl + "/api/auth/reset_password", {
              token: this.token,
              newPassword: this.password,
              verifyPassword: this.passwordConfirm
            });
            this.isDialogSucessShown = true;
            this.loadingBtn = false;
          } else {
            this.snackbartext = "password must contain";
            this.snackbar = true;
            this.loadingBtn = false;
          }
        }
      } catch (error) {
        this.snackbartext = error;
        this.snackbar = true;
        this.loadingBtn = false;
      }
    },
    cancelChangePassword() {
      this.password = "";
      this.passwordConfirm = "";
      setTimeout(() => {
        this.toLogin();
      }, 500);
      // this.isDialogSucessShown = true
    },
    toLogin() {
      this.$router.push({
        name: "login"
      });
    }
  },
  watch: {
    password: function() {
      let regUpper = /[A-Z]/;
      let regLower = /[a-z]/;
      let regNumber = /\d/;
      let regSpecial = /[!@#$%^&*(),.?":{}|<>]/;
      // Check Password Length
      if (this.password.length >= 12) {
        this.checkCharacters = true;
      } else {
        this.checkCharacters = false;
      }

      // Check Upper Case
      let checkUpper = regUpper.test(this.password);
      if (checkUpper) {
        this.checkUpperCase = true;
      } else {
        this.checkUpperCase = false;
      }

      // Check Lower Case
      let checkLower = regLower.test(this.password);
      if (checkLower) {
        this.checkLowerCase = true;
      } else {
        this.checkLowerCase = false;
      }

      // Check Number
      let checkInt = regNumber.test(this.password);
      if (checkInt) {
        this.checkNumber = true;
      } else {
        this.checkNumber = false;
      }

      // Check Special Character
      let checkSpcial = regSpecial.test(this.password);
      if (checkSpcial) {
        this.checkSpecialCharacter = true;
      } else {
        this.checkSpecialCharacter = false;
      }

      // Check All
      if (
        this.checkCharacters &&
        this.checkUpperCase &&
        this.checkNumber &&
        this.checkLowerCase &&
        this.checkSpecialCharacter
      ) {
        this.statusBtn = true;
      } else {
        this.statusBtn = false;
      }
    },
    isDialogSucessShown: function() {
      if (this.isDialogSucessShown) {
        this.refreshIntervalId = setInterval(() => {
          this.coundown -= 1;
        }, 1000);
      }
    },
    coundown: function() {
      if (this.coundown === 0) {
        clearInterval(this.refreshIntervalId);
        setTimeout(() => {
          this.toLogin();
        }, 1000);
      }
    }
  }
};
</script>

<style scoped>
.container-reset {
  background-image: url("../assets/img/bg-blue.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  /* min-height: 960px; */
}
#resetPassword {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.responsive {
  max-width: 80%;
}
.card {
  border-radius: 13px;
}
.card-loading {
  width: 200px !important;
  height: 200px !important;
  background: none !important;
  border: none !important;
  box-shadow: none !important;
  color: #fff !important;
}
.box-layout {
  display: flex;
  flex-direction: row;
  height: 450px;
  width: 850px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 1500px;
  background-color: #02101b;
  border-radius: 13px;
}
.box-reset {
  color: #c4c4c4;
}
.box-reset > h2 {
  position: relative;
  color: #c4c4c4;
  text-align: left;
  margin-left: 40px;
  font-size: 28px;
  margin-top: 100px;
  pointer-events: none;
}
.card {
  border-radius: 13px;
  width: 500px;
  height: 330px;
  margin: 0 auto;
  background: none !important;
  border: none !important;
  box-shadow: none !important;
}
.logo-ragnar {
  position: relative;
  width: 45px;
  height: 45px;
}
.recommend {
  color: #c4c4c4;
  text-align: left;
}
.reset-btn-confirm {
  color: #fff;
  border-radius: 5px;
  text-transform: none;
  outline: none;
  margin-bottom: 15px;
}
.success-change {
  width: 400px;
  height: 200px;
  margin: 0 auto;
  background-color: #27ae60 !important;
  border-radius: 18px;
}
.icon-Success {
  border-radius: 100%;
  background-color: #fff;
  font-size: 60px;
  color: #27ae60;
  margin: 10px auto;
}
.box-success > h3 {
  color: #fff;
  text-align: center;
}
.box-success > span {
  color: #fff;
  text-align: center;
}
@media screen and (max-width: 1264px) {
  .container-reset {
    background-image: url("../assets/img/login/Rectangle.png");
  }
  .box-layout {
    height: 450px;
    width: 650px;
    top: 50%;
    left: 50%;
  }
  .box-reset {
    width: 50%;
    padding-left: 20px;
  }
  .box-reset > h2 {
    margin-left: 20px;
  }
  .card {
    width: 320px;
  }
  .recommend {
    width: 50%;
    padding-left: 30px;
  }
}
@media screen and (max-width: 896px) {
  .box-layout {
    height: 550px;
    width: 580px;
    top: 50%;
    left: 50%;
  }
  .box-reset > h2 {
    position: absolute;
    top: -50px;
    left: 140px;
  }
  .card {
    width: 80%;
    margin-top: 230px;
  }
  .recommend {
    position: absolute;
    top: 100px;
    left: 75px;
  }
}
@media screen and (max-width: 600px) {
  .box-layout {
    width: 530px;
    top: 50%;
    left: 60%;
  }
  .container-reset {
    background-size: cover;
    min-width: 600px;
    min-height: 960px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/resetPassword.vue